<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  #formRef="ngForm"
  [patchForm]="scheduleSettings"
  [canEdit]="[
    accessRights.Settings_write,
    accessRights.ConfigurationOptions_write
  ]"
>
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="schedule-settings"
        >
          <span class="fs-3">
            {{ 'configurationOptionModule.scheduleSettings' | translate }}
          </span>

          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>
    </div>

    <div *ngIf="!isCollapsed" class="card-body" id="schedule-settings">
      <h3 class="fs-4 mb-4">
        {{ 'configurationOptionModule.itemsInSchedule' | translate }}
      </h3>

      <ng-container *ngFor="let option of scheduleOptions">
        <div class="mb-4">
          <fieldset>
            <legend class="form-label">
              {{ option.label | translate }}
              <i
                *ngIf="option.tooltip"
                class="ms-2 fa fa-question-circle"
                role="button"
                tabindex="0"
                [tooltip]="option.tooltip | translate"
              ></i>
            </legend>
            <div class="d-flex align-items-center">
              <div class="btn-group-segment">
                <input
                  type="radio"
                  class="btn-check"
                  [name]="option.name"
                  [id]="option.yesId"
                  (click)="patchItemInSchedule(option.key, true)"
                  autocomplete="off"
                  [checked]="isItemInScheduleEnabled(option.key)"
                />
                <label class="btn" [for]="option.yesId">
                  {{ 'general.yes' | translate }}
                </label>

                <input
                  type="radio"
                  class="btn-check"
                  [name]="option.name"
                  [id]="option.noId"
                  (click)="patchItemInSchedule(option.key, false)"
                  autocomplete="off"
                  [checked]="!isItemInScheduleEnabled(option.key)"
                />
                <label class="btn" [for]="option.noId">
                  {{ 'general.no' | translate }}
                </label>
              </div>
            </div>
          </fieldset>
        </div>
      </ng-container>

      <h3 class="fs-4 mb-4">
        {{ 'configurationOptionModule.scheduleFilter' | translate }}
      </h3>

      <ng-container *ngFor="let option of scheduleFilterOptions">
        <div class="mb-4">
          <fieldset>
            <legend class="form-label">{{ option.label | translate }}</legend>
            <div class="d-flex align-items-center">
              <div class="btn-group-segment">
                <input
                  type="radio"
                  class="btn-check"
                  [name]="option.name"
                  [id]="option.yesId"
                  (click)="patchScheduleFilter(option.key, true)"
                  autocomplete="off"
                  [checked]="isScheduleFilterEnabled(option.key)"
                />
                <label class="btn" [for]="option.yesId">
                  {{ 'general.yes' | translate }}
                </label>

                <input
                  type="radio"
                  class="btn-check"
                  [name]="option.name"
                  [id]="option.noId"
                  (click)="patchScheduleFilter(option.key, false)"
                  autocomplete="off"
                  [checked]="!isScheduleFilterEnabled(option.key)"
                />
                <label class="btn" [for]="option.noId">
                  {{ 'general.no' | translate }}
                </label>
              </div>
            </div>
          </fieldset>
        </div>
      </ng-container>
    </div>

    <div *ngIf="!isCollapsed" class="card-footer d-flex justify-content-end">
      <button
        class="btn btn-primary"
        type="submit"
        [canSee]="[
          accessRights.Settings_write,
          accessRights.ConfigurationOptions_write
        ]"
      >
        {{ 'general.save' | translate }}
      </button>
    </div>
  </section>
</form>
